module.exports = __webpack_public_path__ + "static/media/tm.bdd29cb9.svg";